module.exports = __webpack_public_path__ + "static/media/middle-school.5faef43b.jpg";